module.exports = __webpack_public_path__ + "2020922:8e3d68e2a81bc56d01f1/img/hero-title-img@1x.43234a1.png";